// src/components/Layout.js
import React from 'react';
import Navbar from '../components/navbar/index.js';
import Footer from '../components/footer/index.js';
import "./style.scss";

const Layout = ({ children }) => {
  return (
    <div className='general-layout'>
      <Navbar/>
      <main className='container py-4'>{children}</main>
      <Footer/>
    </div>
  );
};

export default Layout;
